import { useMemo } from 'react';

import { useQuery } from '@apollo/client';

import { GET_ALL_CATEGORIES } from '~/graphql/videos';
import useIsSSR from '~/hooks/useIsSSR';
import { Query } from '~/types';

const useCategoriesTranslations = () => {
  const isSSR = useIsSSR();

  const { loading, data } = useQuery<Pick<Query, 'listVideoCategories'>>(GET_ALL_CATEGORIES, {
    skip: isSSR,
  });

  const categoriesTranslations = useMemo(() => {
    if (data?.listVideoCategories) {
      const obj = {};
      data?.listVideoCategories?.forEach((item) => {
        if (item?.id && item?.title) {
          obj[item?.id] = item?.title;
        }
      });
      return obj;
    }

    return undefined;
  }, [data]);

  return {
    translations: categoriesTranslations,
    loading,
  };
};

export default useCategoriesTranslations;
